<script>
export default {}
</script>

<template>
  <div :class="$style.container">
    <p :class="$style['footer-copyright']">
      Copyright &#169; 2023 Zetrix. All rights reserved.
    </p>
  </div>
</template>

<style lang="scss" module>
@import '@design';
/* stylelint-disable */
.container {
  margin: 0 0;
  text-align: center;
  align-items: center;
  list-style-type: none;
  background-color: $color-main-theme;
  height: 74px;
  padding: 25px 0 0;
}

.footer-copyright {
  margin: 0;
  color: white;
  font-size: 16px;
}
</style>
